import darkBlueLogo from '@/assets/images/logos/dark-blue.svg';
import duotoneDarkLogo from '@/assets/images/logos/duotone-dark.svg';
import duotoneWhiteLogo from '@/assets/images/logos/duotone-white.svg';
import duotoneLogo from '@/assets/images/logos/duotone.svg';
import lightBlueLogo from '@/assets/images/logos/light-blue.svg';
import whiteLogo from '@/assets/images/logos/white.svg';
import { cn } from '@/utils/cn';

interface ShiplexLogoProps {
  color?: 'duotone' | 'duotoneDark' | 'darkBlue' | 'lightBlue' | 'white' | 'whiteBlue' | 'duotoneWhite';
  className?: string;
}

export default function ShiplexLogo({ color = 'white', className }: ShiplexLogoProps) {
  const imgClassName = cn('h-8', className);
  return (
    <div className="flex h-16 items-center justify-center">
      {color === 'duotone' && <img src={duotoneLogo} alt="Shiplex Logo Duotone" className={imgClassName} />}
      {color === 'duotoneDark' && (
        <img src={duotoneDarkLogo} alt="Shiplex Logo Duotone Dark" className={imgClassName} />
      )}
      {color === 'darkBlue' && <img src={darkBlueLogo} alt="Shiplex Logo Dark Blue" className={imgClassName} />}
      {color === 'lightBlue' && <img src={lightBlueLogo} alt="Shiplex Logo Light Blue" className={imgClassName} />}
      {color === 'white' && <img src={whiteLogo} alt="Shiplex Logo White" className={imgClassName} />}
      {color === 'duotoneWhite' && (
        <img src={duotoneWhiteLogo} alt="Shiplex Logo Duotone White" className={imgClassName} />
      )}
    </div>
  );
}
